import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import Button from "../../components/common/Button";
import { getJoinLink } from "../../backend/landing/joinLink";
import { getWeekendInfoByName } from "../../backend/weekends/weekendInfo";
import { sanitizeHTML } from "../../utils/htmlSanitizer";

const LandingBottomText = ({ weekendId }: {weekendId:number}) => {
  const showBigLogo = useMediaQuery({ query: `(min-width: 1024px)` });
  const isMobile = useMediaQuery({ query: `(max-width: 768px)` });
  return (
    <div style={{ ...styles.cardWrapper, flexDirection: isMobile ? "column" : "row" }}>
      <div style={{ ...styles.cardContainer, margin: isMobile ? "3.5rem auto" : "5rem auto" }}>
        <p
          style={{
            ...styles.mainHeading,
            fontSize: isMobile ? "9vw" : "clamp(3rem,4vw,5rem)",
            textAlign: isMobile ? "center" : "left",
          }}
          dangerouslySetInnerHTML={{ __html: sanitizeHTML(getWeekendInfoByName(weekendId,"infoBottomUpperText")) }}
        ></p>
        <p
          style={{
            ...styles.mainHeading,
            color: "var(--white)",
            fontSize: isMobile ? "9vw" : "clamp(3rem,4vw,5rem)",
            textAlign: isMobile ? "center" : "left",
          }}
          dangerouslySetInnerHTML={{ __html: sanitizeHTML(getWeekendInfoByName(weekendId,"infoBottomLowerText")) }}
        >
        </p>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <Button
            text={"ПОДАТИ ЗАЯВКУ"}
            external_link={getJoinLink(weekendId)}
            textColor="var(--black)"
            hoverTextColor="var(--orange)"
            border="3px solid var(--black)"
            hoverBorder="3px solid var(--black)"
            backgroundColor="var(--orange)"
            hoverBackgroundColor="var(--black)"
            fontSize={isMobile ? "9vw" : "3rem"}
            padding={isMobile ? "1rem 0rem" : "1rem 2rem"}
            fontWeight="bold"
            containerProps={isMobile ? { width: "var(--main-container-width)" } : {}}
            isSimple={true}
          />
        </div>
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  cardWrapper: {
    display: "flex",
    width: "100%",
    backgroundColor: "var(--olive)",
    overflow: "visible",
  },
  cardContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    width: "var(--main-container-width)",
  },
  mainHeading: {
    color: "var(--dark-grey)",
    fontWeight: "bold",
    marginBottom: "4rem",
  },
};

export default LandingBottomText;
